export const optionsList = {
  persona_type: [
    { label: 'Teacher', value: 'TEACHER' },
    { label: 'Internal User', value: 'INTERNAL_USER' },
  ],
}
